import { render, staticRenderFns } from "./user-management.vue?vue&type=template&id=dfaa50be&"
import script from "./user-management.vue?vue&type=script&lang=js&"
export * from "./user-management.vue?vue&type=script&lang=js&"
import style0 from "./user-management.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports